import { ChangeDetectionStrategy, Component } from '@angular/core'

import { ToastIconMapping } from './toast.constants'
import { Toast as PrimeToast } from '@shared/modules/primeng-clone/toast'
import { PrimeTemplate } from '@shared/modules/primeng-clone/api'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'bo-toast',
  templateUrl: './toast.html',
  styleUrls: ['./toast.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PrimeToast, PrimeTemplate, TranslatePipe],
})
export class Toast {
  toastIconMapping = ToastIconMapping
}
